import { IconName, IconVariant } from './enums';
import { joinClassNames } from '../../../../utils';
import { DetailedIcons } from './consts';
import { getIconAttributes } from './IconList';
import styles from './styles.module.scss';

type SizeOptions = string | number;

type Dimensions = {
  height?: SizeOptions;
  width?: SizeOptions;
  [key: string]: SizeOptions | undefined;
};

export type IconProps = {
  /**
   * Takes Enum `IconName`
   */
  name: IconName;
  marginLeft?: 'small' | 'large';
  marginRight?: 'small' | 'large';
  size?: SizeOptions | Dimensions;
  strokeWidth?: number;
  /**
   * Takes Enum `IconVariant`
   */
  variant?: IconVariant;
  title?: string;
  className?: string;
};

const getDimensions = (value: SizeOptions | Dimensions): Dimensions => {
  const dimensions = {};

  ['height', 'width'].map((propertyName) => {
    const propertyValue =
      (typeof value === 'object' && value[propertyName]) || (typeof value !== 'object' && value) || 'auto';
    return Object.assign(dimensions, { [propertyName]: propertyValue });
  });

  return dimensions;
};

/**
 * @deprecated Use individual Icon components
 */
export const Icon = ({
  name,
  marginLeft,
  marginRight,
  size,
  strokeWidth,
  variant = IconVariant.Default,
  title,
  className,
}: IconProps) => {
  const { viewBox, path } = getIconAttributes(name, strokeWidth) || {};

  const renderSize = size || (DetailedIcons.includes(name) ? '4em' : '1em');
  const { height, width } = getDimensions(renderSize);

  return (
    <svg
      className={joinClassNames(
        styles.icon,
        variant !== 'default' && styles[variant],
        height === 'auto' && styles.heightAuto,
        width === 'auto' && styles.widthAuto,
        marginLeft && styles[`marginLeft--${marginLeft}` as keyof typeof styles],
        marginRight && styles[`marginRight--${marginRight}` as keyof typeof styles],
        className
      )}
      width={width !== 'auto' ? width : undefined}
      height={height !== 'auto' ? height : undefined}
      viewBox={viewBox}
    >
      {title && <title>{title}</title>}
      {path}
    </svg>
  );
};

Icon.displayName = 'Icon';
